import { defineComponent, ref, onMounted, onUnmounted, watch, createElementBlock, openBlock, createElementVNode } from 'vue';
import { useElementVisibility, useDocumentVisibility } from './basler-components.es354.js';
import { WaveCanvasRenderer } from './basler-components.es356.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WaveCanvasBackground",
  props: {
    colorMode: { default: "dark" },
    color1: { default: "#1D3EA5" },
    color2: { default: "#1D305F" },
    usePostProcessing: { type: Boolean, default: false },
    useUnrealBloom: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const color1 = ref(
      props.colorMode == "light" || props.colorMode == "dark" ? "#011C53" : props.colorMode == "dark-purple" ? "#743ac2" : props.color1
    );
    const color2 = ref(
      props.colorMode == "light" || props.colorMode == "dark" ? "#002FA6" : props.colorMode == "dark-purple" ? "#2e185e" : props.color2
    );
    const usePostProcessing = ref(props.usePostProcessing);
    const useUnrealBloom = ref(props.useUnrealBloom);
    const webglcanvas = ref(null);
    const waveCanvasRenderer = new WaveCanvasRenderer({
      color1: color1.value,
      color2: color2.value,
      showDebugControls: false,
      usePostProcessing: usePostProcessing.value,
      useUnrealBloom: useUnrealBloom.value
    });
    const onWindowResizeFunction = () => {
      waveCanvasRenderer.onResize();
    };
    const wrapper = ref(null);
    const wrapperIsVisible = useElementVisibility(wrapper);
    const documentVisibility = useDocumentVisibility();
    onMounted(() => {
      if (webglcanvas.value) {
        waveCanvasRenderer.init(webglcanvas.value);
        waveCanvasRenderer.renderLoop();
      }
      window.addEventListener("resize", onWindowResizeFunction, {
        passive: true
      });
      setTimeout(() => {
        waveCanvasRenderer.onResize();
      }, 200);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", onWindowResizeFunction);
    });
    watch(
      wrapperIsVisible,
      (newVal) => {
        waveCanvasRenderer.setPaused(!newVal);
      },
      { immediate: true, deep: true }
    );
    watch(
      documentVisibility,
      (newVal) => {
        if (newVal === "hidden") {
          waveCanvasRenderer.setPaused(true);
        } else if (wrapperIsVisible.value) {
          waveCanvasRenderer.setPaused(false);
        }
      },
      { immediate: true, deep: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "wave-canvas-background",
        ref_key: "wrapper",
        ref: wrapper
      }, [
        createElementVNode("canvas", {
          class: "cta-canvas-webglbackground",
          ref_key: "webglcanvas",
          ref: webglcanvas
        }, null, 512)
      ], 512);
    };
  }
});

export { _sfc_main as default };
